import React, { Component } from "react";
import { color } from "../common/constants";

class WaitlistInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focus: false,
      blur: false,
    };
  }

  getBorderColor = () => {
    if (this.state.focus) {
      return color.primary;
    }
    if (this.state.blur) {
      if (
        this.props.validation === "email" &&
        !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.props.value)
      ) {
        return "red";
      }
      if (
        this.props.validation === "gstno" &&
        !/^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([Zz]){1}([a-zA-Z0-9]){1}?$/.test(
          this.props.value
        )
      ) {
        return "red";
      }
      if (
        this.props.validation === "mobile" &&window.msurl !== 'shwesanthu.com' &&
        (this.props.value < 6000000000 || (this.props.value + "").length !== 10)
      ) {
        return "red";
      }
      if (
        this.props.validation === "mobile" && window.msurl === 'shwesanthu.com' &&
        ((this.props.value + "").length < 7 )
      ) {
        return "red";
      }
      if (!this.props.value || this.props.value === "") {
        return "red";
      }
    }
    return "#ddd";
  };

  render() {
    return (
      <div style={{ ...this.props.style, position: "relative" }}>
        <input
          type="password"
          name="password"
          style={{
            position: "absolute",
            opacity: 0,
            height: "0px",
            width: "0px",
            margin: "0px",
            padding: "0px",
          }}
        />
        <input
          type={this.props.type}
          value={this.props.value}
          onFocus={() => this.setState({ focus: true, blur: false })}
          onBlur={() => this.setState({ focus: false, blur: true })}
          onChange={this.props.handleChange}
          onClick = {this.props.handleClick}
          tabIndex={this.props.tab}
          name={this.props.name}
          maxLength={this.props.max}
          autoFocus={this.props.tab === 1 || this.props.autoFocus}
          autoComplete={this.props.autoComplete || "none" }
          readOnly={this.props.readOnly}
          disabled={this.props.disabled}
          pattern={this.props.pattern}
          style={{
            background: "transparent",
            border:
              !this.state.focus && !this.state.blur
                ? "1px solid"
                : "2px solid ",
            outline: 0,
            width: "100%",
            padding: this.props.isImg ? "20px 0 5px 40px" : "18px 10px",
            borderColor:!this.props.waitlistborder ? this.getBorderColor():'#ddd',
            transition: "0.3s ease",
            borderRadius: this.props.InputRadius || "6px",
            height: this.props.InputHeight || "45px",
          }}
        />
        <label
          style={{
            position: "absolute",
            left: this.props.isImg ? "40px" : "7px",
            fontSize:
              this.state.focus || (this.props.value + "").length > 0
                ? "12px"
                : "inherit",
            bottom:
              this.state.focus || (this.props.value + "").length > 0
                ? "38px"
                : "15px",
            transition: "0.3s ease",
            pointerEvents: "none",
            color: this.state.focus ? color.primary : "inherit",
            padding: "0 5px",
            background: "#fff",
          }}
        >
          {this.props.placeholder}
        </label>
        {this.props.isImg ? (
          <img
            src={"/img/email.svg"}
            alt="email"
            style={{ position: "absolute", left: 0, bottom: 0 }}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default WaitlistInput;
